import React, { useEffect, useState } from 'react'
import SideBar from '../../components/SideBar/SideBar'
import dashboardStyle from './DashboardPage.module.css'
import human from '../../../assets/images/lady-img.png'
import CoordinatorHeader from '../../components/Header/CoordinatorHeader'
import CoordinatorPageBar from '../../components/CoordinatorPageBar/CoordinatorPageBar'
import CoordinatorMobilPageBar from '../../components/CoordinatorMobilPageBar/CoordinatorMobilPageBar'
import CoordinatorDashboardPage from '../coordinatordashboard/CoordinatorDashboardPage.jsx';
import AddEventPage from "../../pages/addevent/AddEventPage"
import { Link } from 'react-router-dom';
import { FaCirclePlus } from "react-icons/fa6";
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

export default function DashboardPage() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const cordinatorID = localStorage.getItem('cordinator_id');
  // const cordinatorFName = localStorage.getItem('coordinatorFName');
  // const cordinatorLName = localStorage.getItem('coordinatorLName');
  // const cordinatorPosition = localStorage.getItem('coordinatorPosition');
  // const cordinatorPic = localStorage.getItem('coordinatorPic');
  const navigate = useNavigate();
  const [hasEvents, setHasEvents] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkEvents = async () => {
      try {
        const coordinatorId = localStorage.getItem('cordinator_id');

        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_events.php?coordinator_id=${coordinatorId}`
        );

        const data = await response.json();

        if (data.success && Array.isArray(data.events) && data.events.length > 0) {
          setHasEvents(true);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    checkEvents();
  }, []);

  if (loading) return null; // or a loader component

  if (hasEvents) {
    navigate('/coordinator-dashboard');
    return null;
  }

  const addhandleClick = () => {
    // Navigate to an Add Event Page route
    navigate('/add-event');  // Change '/AddEventPage' to your desired route
  };

  return (
    <>
      <CoordinatorHeader />
      {isMobile ? (
        <div className={dashboardStyle.dashboardmobiltopbar}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <CoordinatorMobilPageBar />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={dashboardStyle.dashboarddesktoptopbar}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <CoordinatorPageBar />
              </div>
            </div>
          </div>
        </div>
      )}

      {isMobile ? (
        <div className={dashboardStyle.mobildashboardpage}>
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12'>
                <div className={dashboardStyle.mobildashboardContent}>
                  <h4> Welcome to <br /> AuthorMeet! </h4>
                  <p> Are you planning an engaging author event that will captivate your audience?
                    Whether you’re organizing a school visit, a corporate keynote, or a literary
                    festival, AuthorMeet connects you with a diverse selection of talented authors
                    who are ready to inspire and engage.
                  </p>
                  <p> Click “<span className={dashboardStyle.mdcColor}><Link to="/add-event" element={<AddEventPage />}>Add an Event</Link></span>” to the below to create your first author event. </p>
                  <button className={`${dashboardStyle.mobiladdeventButton} btn btn-light w-100`} onClick={addhandleClick}>
                    <FaCirclePlus className={dashboardStyle.mobilbtnIconplus} /> Add an Event
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={dashboardStyle.maindashboardpage}>
          <div className='container'>
            <div className='row'>
              <div className='col' style={{ maxWidth: '275px' }}>
                <SideBar />
              </div>
              <div className="col">
                <div className={dashboardStyle.dashboardpageWrap}>
                  <div className='row'>
                    <div className='col-lg-7'>
                      <div className={dashboardStyle.dashboardpageContent}>
                        <h4> Welcome to AuthorMeet! </h4>
                        <p> Are you planning an engaging author event that will captivate your audience? Whether you’re
                          organizing a school visit, a corporate keynote, or a literary festival, AuthorMeet connects
                          you with a diverse selection of talented authors who are ready to inspire and engage.
                        </p>
                        <p> Click “<Link to="/add-event" element={<AddEventPage />}><b>Add an Event</b></Link>” to the right to create your first author event.</p>
                      </div>
                    </div>
                    <div className='col-lg-5'>
                      <div className={dashboardStyle.dashboardpageImg}>
                        <img src={human} className='w-100' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
